import { Utils } from '@Util/utils'
import './styles.scss'
import { ReactSVG } from 'react-svg'

const CLASS_NAME = `ticket-status-pill`

export type TicketStatusPillProps = {
  text: string | null
  iconUrl: string | null
  status: 'win' | 'non-win' | 'pending'
}

export type TicketStatusPillWithWinningsProps = {
  type: 'PENDING' | 'COMPLETED'
  totalWinnings: number | null
  iconUrl: string | null
}

export const TicketStatusPillWithWinnings = ({
  totalWinnings,
  type,
  iconUrl,
}: TicketStatusPillWithWinningsProps) => {
  if (type === 'PENDING') {
    return <TicketStatusPill text={null} status="pending" iconUrl={iconUrl} />
  }

  const status = totalWinnings! > 0 ? 'win' : 'non-win'
  const winText = Utils.convertCentsNumberToDollarString(totalWinnings!)

  return <TicketStatusPill text={winText} status={status} iconUrl={iconUrl} />
}

export const TicketStatusPill = (props: TicketStatusPillProps) => {
  return (
    <div className={`${CLASS_NAME}`} data-state={props.status}>
      {props.iconUrl ? (
        props.status === 'pending' ? (
          <ReactSVG
            className={`${CLASS_NAME}__icon`}
            src={props.iconUrl}
            data-state={props.status}
            title={'drawing pending'}
          />
        ) : (
          <img className={`${CLASS_NAME}__icon`} src={props.iconUrl} aria-hidden={'true'} />
        )
      ) : null}
      {props.text ? <div className={`${CLASS_NAME}__label`}>{props.text}</div> : null}
    </div>
  )
}
